(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("9HhFF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "EmbedRelatedMedia", function () { return $70f5d6545aca70c4$export$c68a40e54824c55b; });
$parcel$export(module.exports, "EmbedNode", function () { return $70f5d6545aca70c4$export$f17abade15659f89; });
$parcel$export(module.exports, "make", function () { return $70f5d6545aca70c4$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $70f5d6545aca70c4$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $70f5d6545aca70c4$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $fvE4w = parcelRequire("fvE4w");

var $ePRCc = parcelRequire("ePRCc");

var $bbixw = parcelRequire("bbixw");

var $5bEXW = parcelRequire("5bEXW");

var $cq0ZS = parcelRequire("cq0ZS");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $3uZKH = parcelRequire("3uZKH");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $37BLX = parcelRequire("37BLX");

var $cdK26 = parcelRequire("cdK26");

var $lBn5n = parcelRequire("lBn5n");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $dhngN = parcelRequire("dhngN");

var $8adqh = parcelRequire("8adqh");

var $1z5jA = parcelRequire("1z5jA");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");

var $hM6fK = parcelRequire("hM6fK");
function $70f5d6545aca70c4$var$SectionApp$EmbedRelatedMedia(Props) {
    var config = Props.config;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var attributes = Props.attributes;
    var shopifyProductId = $cdK26.getProductPageProductId(undefined);
    var shopifyCollectionId = $cdK26.getCollectionPageCollectionId(undefined);
    var productId = $2whNH.orElse(shopifyProductId, $2whNH.flatMap(attributes, function(attr) {
        return attr.relatedProduct;
    }));
    var categoryId = $2whNH.orElse(shopifyCollectionId, $2whNH.flatMap(attributes, function(attr) {
        return attr.relatedCategory;
    }));
    var relatedMediaSource = productId !== undefined ? {
        TAG: /* ByProductIds */ 0,
        _0: [
            productId
        ]
    } : categoryId !== undefined ? {
        TAG: /* ByCategoryId */ 1,
        _0: categoryId
    } : /* NoSource */ 0;
    var relatedMediaCount = $g85JO.useMemo(function() {
        return $i7mYY.get($1xf0g.keepMapCategories(config.categories, function(category) {
            var connection = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
            if (connection !== undefined && $7bjme.equal(connection.categoryId, categoryId)) return connection.relatedMediaCount;
        }), 0);
    }, []);
    var relatedMediaCardSize = $2whNH.map(attributes, function(attr) {
        var match = attr.sectionCardSize;
        if (match !== undefined && match !== "medium") {
            if (match === "small") return /* Small */ 0;
            else return /* Large */ 2;
        } else return /* Medium */ 1;
    });
    var relatedMediaCardShape = $2whNH.map(attributes, function(attr) {
        var match = attr.sectionCardShape;
        if (match !== undefined && match !== "square") {
            if (match === "portrait") return /* Tall */ 0;
            else return /* Circle */ 2;
        } else return /* Square */ 1;
    });
    var tmp = {
        at: /* StandaloneEmbed */ 3,
        scrollableContainerRef: scrollableContainerRef,
        source: relatedMediaSource,
        className: $ezf3v.prefix("bg-main text-primary")
    };
    if (relatedMediaCount !== undefined) tmp.count = relatedMediaCount;
    if (relatedMediaCardShape !== undefined) tmp.shape = $loT9g.valFromOption(relatedMediaCardShape);
    if (relatedMediaCardSize !== undefined) tmp.size = $loT9g.valFromOption(relatedMediaCardSize);
    return /*#__PURE__*/ $g85JO.createElement($1z5jA.Slider.make, tmp);
}
$70f5d6545aca70c4$var$SectionApp$EmbedRelatedMedia.displayName = "SectionApp.EmbedRelatedMedia";
var $70f5d6545aca70c4$export$c68a40e54824c55b = {
    make: $70f5d6545aca70c4$var$SectionApp$EmbedRelatedMedia
};
function $70f5d6545aca70c4$var$SectionApp$EmbedNode(Props) {
    var config = Props.config;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var attributes = Props.attributes;
    var match = $efwy1.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    var targetedNode = $g85JO.useMemo(function() {
        var match = $2whNH.flatMap(attributes, function(attr) {
            return attr.sectionType;
        });
        if (match !== undefined) {
            if (match === "root") return $2whNH.map(config.settings.indexNode, function(root) {
                var newrecord = $7bjme.obj_dup(root);
                newrecord.categoryType = {
                    TAG: /* Standard */ 1,
                    _0: {
                        firstCard: undefined,
                        externalConnection: undefined,
                        children: config.categories,
                        loadMoreChildren: undefined,
                        totalChildren: 0,
                        link: undefined,
                        products: [],
                        taggedMedia: undefined,
                        imageHotspots: undefined,
                        imageWidth: undefined,
                        imageHeight: undefined
                    }
                };
                newrecord.showDescription = false;
                newrecord.showTitle = false;
                return newrecord;
            });
            else if (match === "related-media") return;
            else return $2whNH.flatMap($2whNH.flatMap(attributes, function(attr) {
                return attr.sectionNode;
            }), function(nodeId) {
                return $cq0ZS.getCategoryById(config.categories, nodeId);
            });
        }
    }, [
        attributes,
        config
    ]);
    var targetedUserSelectedLayout = $2whNH.map(targetedNode, function(node) {
        return node.userSelectedLayout;
    });
    var targetedNodeLayout;
    if (targetedUserSelectedLayout !== undefined && typeof targetedUserSelectedLayout !== "number") switch(targetedUserSelectedLayout.TAG | 0){
        case /* SubCategoriesGrid */ 2:
        case /* ProductGrid */ 3:
            targetedNodeLayout = {
                TAG: /* GridLayout */ 1,
                _0: targetedUserSelectedLayout._0
            };
            break;
        default:
            targetedNodeLayout = {
                TAG: /* SliderLayout */ 0,
                _0: targetedUserSelectedLayout._0
            };
    }
    else targetedNodeLayout = undefined;
    var targetedPreferedContentType;
    if (targetedUserSelectedLayout !== undefined && typeof targetedUserSelectedLayout !== "number") switch(targetedUserSelectedLayout.TAG | 0){
        case /* ProductGrid */ 3:
        case /* ProductSlider */ 4:
            targetedPreferedContentType = /* Products */ 0;
            break;
        default:
            targetedPreferedContentType = /* Category */ 1;
    }
    else targetedPreferedContentType = undefined;
    var onCategoryClick = $37BLX.countBottombarElementsByNamespace(match.namespace) > 0 ? match$1.onCategoryClick : undefined;
    if (targetedNode === undefined) return /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
        error: $4QdUt.makeError(false, "No targeted node")
    });
    if (targetedNodeLayout === undefined) return /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
        error: $4QdUt.makeError(false, "No targeted layout")
    });
    if (targetedPreferedContentType === undefined) return /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
        error: $4QdUt.makeError(false, "No targeted content type")
    });
    var tmp = {
        index: 0,
        preferredContentType: targetedPreferedContentType,
        category: targetedNode,
        layout: targetedNodeLayout,
        scrollableContainerRef: scrollableContainerRef,
        className: $ezf3v.prefix("bg-main text-primary")
    };
    if (onCategoryClick !== undefined) tmp.onTitleClick = $loT9g.valFromOption(onCategoryClick);
    return /*#__PURE__*/ $g85JO.createElement($3uZKH.make, tmp);
}
$70f5d6545aca70c4$var$SectionApp$EmbedNode.displayName = "SectionApp.EmbedNode";
var $70f5d6545aca70c4$export$f17abade15659f89 = {
    make: $70f5d6545aca70c4$var$SectionApp$EmbedNode
};
function $70f5d6545aca70c4$var$SectionApp(Props) {
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var scrollableContainerRef = $g85JO.useRef(null);
    $aSJcu.use(undefined);
    var match$1 = $hBcYV.useRouter(undefined);
    var quickViewUnderlyingRoute = match$1.quickViewUnderlyingRoute;
    var route = match$1.route;
    var match$2 = $8E2YL.use(undefined);
    var config = match$2.config;
    var contextualRoot = $lBn5n.useContextualRoot(/* Open */ 2, embedType, window.location.pathname);
    var pageOnlyHasSection = $37BLX.countBottombarElementsByNamespace(namespace) === 0 && $37BLX.countInlineElementsByNamespace(namespace) === 0 && $37BLX.countLauncherElementsByNamespace(namespace) === 0;
    var match$3 = $2whNH.flatMap(attributes, function(attr) {
        return attr.sectionType;
    });
    var tmp;
    tmp = typeof route === "number" || !(route.TAG === /* QuickView */ 3 && pageOnlyHasSection) ? null : /*#__PURE__*/ $g85JO.createElement($b8WNX.make, {});
    var tmp$1;
    var exit = 0;
    var exit$1 = 0;
    if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */ 2)) exit = 1;
    else exit$1 = 2;
    if (exit$1 === 2) {
        if (typeof route === "number" || route.TAG !== /* PDP */ 2) tmp$1 = null;
        else exit = 1;
    }
    if (exit === 1) tmp$1 = pageOnlyHasSection ? /*#__PURE__*/ $g85JO.createElement($hM6fK.make, {}) : null;
    var tmp$2 = {
        config: config,
        embedType: embedType,
        children: /*#__PURE__*/ $g85JO.createElement($fvE4w.Provider.make, {
            value: /* Open */ 2,
            children: null
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(scrollableContainerRef)
        }, match$3 !== undefined ? match$3 === "related-media" ? /*#__PURE__*/ $g85JO.createElement($70f5d6545aca70c4$var$SectionApp$EmbedRelatedMedia, {
            config: config,
            scrollableContainerRef: scrollableContainerRef,
            attributes: attributes
        }) : /*#__PURE__*/ $g85JO.createElement($70f5d6545aca70c4$var$SectionApp$EmbedNode, {
            config: config,
            scrollableContainerRef: scrollableContainerRef,
            attributes: attributes
        }) : /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
            error: $4QdUt.makeError(false, "Unknown value for attribute `type`")
        }), tmp, tmp$1), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: config.settings.cart,
            children: /*#__PURE__*/ $g85JO.createElement($8adqh.make, {})
        }))
    };
    if (attributes !== undefined) tmp$2.attributes = $loT9g.valFromOption(attributes);
    if (contextualRoot !== undefined) tmp$2.contextualRoot = $loT9g.valFromOption(contextualRoot);
    return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "section",
        portal: false,
        children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp$2)
    });
}
$70f5d6545aca70c4$var$SectionApp.displayName = "SectionApp";
var $70f5d6545aca70c4$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($70f5d6545aca70c4$var$SectionApp);
var $70f5d6545aca70c4$export$aa541d093b11ace2 = $70f5d6545aca70c4$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("fvE4w", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $b4a8d5b63998f43c$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "Provider", function () { return $b4a8d5b63998f43c$export$2881499e37b75b9a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");
function $b4a8d5b63998f43c$export$1f96ae73734a86cc(param) {
    var match = $g85JO.useState(function() {
        return /* Closed */ 0;
    });
    var setState = match[1];
    var stateRef = $g85JO.useRef(/* Closed */ 0);
    var handleChange = function handleChange(next) {
        $iv6Yc._1(setState, function(param) {
            return next;
        });
        stateRef.current = next;
    };
    var onClose = function onClose(param) {
        handleChange(/* Closed */ 0);
    };
    var onOpen = function onOpen(param) {
        handleChange(/* Open */ 2);
    };
    var onOpening = function onOpening(param) {
        handleChange(/* Opening */ 1);
    };
    return {
        state: match[0],
        stateRef: stateRef,
        onOpening: onOpening,
        onOpen: onOpen,
        onClose: onClose
    };
}
var $b4a8d5b63998f43c$var$context = /*#__PURE__*/ $g85JO.createContext(/* Closed */ 0);
var $b4a8d5b63998f43c$var$provider = $b4a8d5b63998f43c$var$context.Provider;
function $b4a8d5b63998f43c$var$DrawerState$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($b4a8d5b63998f43c$var$provider, {
        value: value,
        children: children
    });
}
$b4a8d5b63998f43c$var$DrawerState$Provider.displayName = "DrawerState.Provider";
function $b4a8d5b63998f43c$var$use$1(param) {
    return $g85JO.useContext($b4a8d5b63998f43c$var$context);
}
var $b4a8d5b63998f43c$export$2881499e37b75b9a = {
    context: $b4a8d5b63998f43c$var$context,
    provider: $b4a8d5b63998f43c$var$provider,
    make: $b4a8d5b63998f43c$var$DrawerState$Provider,
    use: $b4a8d5b63998f43c$var$use$1
};
 /* context Not a pure module */ 
});

parcelRegister("37BLX", function(module, exports) {

$parcel$export(module.exports, "countInlineElementsByNamespace", function () { return $245f535c80fa97b7$export$7460c80d7c5cf75c; });
$parcel$export(module.exports, "countBottombarElementsByNamespace", function () { return $245f535c80fa97b7$export$3a44f3abf1840775; });
$parcel$export(module.exports, "countLauncherElementsByNamespace", function () { return $245f535c80fa97b7$export$ac754b9504a93a08; });
$parcel$export(module.exports, "countSectionElementsByNamespace", function () { return $245f535c80fa97b7$export$b75c7a415a35e365; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $h6rW7 = parcelRequire("h6rW7");
function $245f535c80fa97b7$export$36d3479b5d03ac38(el) {
    var namespace = el.getAttribute("data-namespace");
    if (namespace == null) return $h6rW7.empty;
    else return $h6rW7.fromString(namespace);
}
function $245f535c80fa97b7$export$d0ebfc305a7a6844(elements, namespace) {
    var namespace$1 = $2whNH.getWithDefault(namespace, $h6rW7.empty);
    return $i7mYY.keep($2whNH.getWithDefault($2whNH.map(elements, $d3YYW.values), []), function(element) {
        return $7bjme.equal($245f535c80fa97b7$export$36d3479b5d03ac38(element), namespace$1);
    });
}
function $245f535c80fa97b7$export$a82d8d7911f406ff(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace);
}
function $245f535c80fa97b7$export$310f9fbcf0732046(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace);
}
function $245f535c80fa97b7$export$677c1fd84b0cad4f(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace);
}
function $245f535c80fa97b7$export$bbd7846266bc9fe8(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace);
}
function $245f535c80fa97b7$export$58368f7b4fc9b76d(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace);
}
function $245f535c80fa97b7$export$7460c80d7c5cf75c(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsInline, namespace).length;
}
function $245f535c80fa97b7$export$3a44f3abf1840775(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElements, namespace).length;
}
function $245f535c80fa97b7$export$ac754b9504a93a08(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsLauncher, namespace).length;
}
function $245f535c80fa97b7$export$b75c7a415a35e365(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsSection, namespace).length;
}
function $245f535c80fa97b7$export$65ea36736e2b48c7(namespace) {
    return $245f535c80fa97b7$export$d0ebfc305a7a6844(window.smartNavElementsPDP, namespace).length;
}
 /* No side effect */ 
});

parcelRegister("lBn5n", function(module, exports) {

$parcel$export(module.exports, "useContextualRoot", function () { return $fb9ef608eb76e9b2$export$fd42e504a4d8f825; });
$parcel$export(module.exports, "useContextualL1s", function () { return $fb9ef608eb76e9b2$export$f20aa461418ac738; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $bygWp = parcelRequire("bygWp");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $fb9ef608eb76e9b2$export$b829272b1dcc6798(url) {
    try {
        return $2whNH.map($2whNH.map($bygWp.maybeMakeUrl(url), function(prim) {
            return prim.pathname;
        }), function(prim) {
            return prim.toLowerCase();
        });
    } catch (exn) {
        return;
    }
}
function $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories) {
    if (urlPathname === "/") return;
    var l1Match = topLevelCategories.find(function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var link = $1xf0g.getCategoryLink(cat);
        if (link !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(link));
        else return false;
    });
    var l1Match$1 = l1Match === undefined ? undefined : $loT9g.some(l1Match);
    var l2OrDeeperMatch = $1xf0g.findCategoryBy(topLevelCategories, function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var match = $1xf0g.getCategoryLink(cat);
        if (l1Match !== undefined) {
            if (match !== undefined && $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match))) return l1Match.id !== cat.id;
            else return false;
        } else if (match !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match));
        else return false;
    });
    if (l2OrDeeperMatch !== undefined) return l2OrDeeperMatch;
    else return l1Match$1;
}
function $fb9ef608eb76e9b2$export$7f3d9773c89e0196(topLevelCategories, category) {
    return $1xf0g.getCategoryParentById(topLevelCategories, category.id);
}
function $fb9ef608eb76e9b2$export$2b5083f21a7660c3(categories, fallback) {
    if ($i7mYY.keep(categories, function(category) {
        return category.visibleInMenuBar;
    }).length === 0) return fallback;
    else return categories;
}
function $fb9ef608eb76e9b2$export$fd42e504a4d8f825(drawerState, embedType, urlPathname) {
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var canUseContextualL1s = embedType !== /* Inline */ 1 && settings.contextualL1s && drawerState !== /* Open */ 2 || settings.contextualInline && embedType === /* Inline */ 1;
    if (canUseContextualL1s) return $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, match.categories);
}
function $fb9ef608eb76e9b2$export$f20aa461418ac738(embedType, drawerState, urlPathname) {
    var hasNavigatedAwayFromContextualRoot = $g85JO.useRef(false);
    var match = $8E2YL.use(undefined).config;
    var topLevelCategories = match.categories;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var canUseContextualL1s = (embedType === /* Bottombar */ 0 || embedType === /* Launcher */ 2) && match.settings.contextualL1s && drawerState !== /* Open */ 2;
    if (!canUseContextualL1s) return topLevelCategories;
    var contextualRoot = $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories);
    var isInRootsOrParentPath;
    if (contextualRoot !== undefined) {
        var isRootPLP = $1xf0g.isPLP(contextualRoot);
        var inRootsPath = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
            return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
        }).some(function(cat) {
            return cat.id === contextualRoot.id;
        });
        if (inRootsPath) isInRootsOrParentPath = true;
        else {
            var tmp = false;
            if (isRootPLP) {
                var rootParent = $1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id);
                tmp = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
                    return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
                }).some(function(cat) {
                    return cat.id === $2whNH.mapWithDefault(rootParent, "", function(parent) {
                        return parent.id;
                    });
                });
            }
            isInRootsOrParentPath = tmp;
        }
    } else isInRootsOrParentPath = false;
    if (!isInRootsOrParentPath && drawerState === /* Open */ 2) hasNavigatedAwayFromContextualRoot.current = true;
    if (drawerState === /* Closed */ 0) hasNavigatedAwayFromContextualRoot.current = false;
    var canUseContextualL1s$1 = canUseContextualL1s && (drawerState === /* Closed */ 0 || isInRootsOrParentPath) && (drawerState === /* Closed */ 0 || !hasNavigatedAwayFromContextualRoot.current);
    if (contextualRoot === undefined) return topLevelCategories;
    if (!canUseContextualL1s$1) return topLevelCategories;
    var match$1 = contextualRoot.listPageActiveLayout;
    var isPLP;
    isPLP = typeof match$1 === "number" || match$1.TAG !== /* ProductGrid */ 3 ? false : true;
    if (isPLP) return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($2whNH.mapWithDefault($1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id), topLevelCategories, $1xf0g.getChildren), topLevelCategories);
    else return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($1xf0g.getChildren(contextualRoot), topLevelCategories);
}
 /* react Not a pure module */ 
});

parcelRegister("8adqh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5f19ab6e1e369baa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $5f19ab6e1e369baa$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("9E7Ru"));
});
function $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($5f19ab6e1e369baa$var$component, Props);
}
$5f19ab6e1e369baa$var$MiniCartDrawer_Lazy.displayName = "MiniCartDrawer_Lazy";
var $5f19ab6e1e369baa$export$dd44f18ab656f3bb = $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("9E7Ru", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("by1hz")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fW0Yj")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6Tuh6")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("ebd07"))
]).then(function() {
    return parcelRequire("67Br4");
});

});


parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("ib7cK"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("ib7cK", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fW0Yj")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("i1uwo")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1YO94")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6Tuh6")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});


parcelRegister("hM6fK", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $cf0bc514c141a324$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $cf0bc514c141a324$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $cf0bc514c141a324$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("cwRuj"));
});
function $cf0bc514c141a324$var$ProductDetailsPage_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($cf0bc514c141a324$var$component, Props);
}
$cf0bc514c141a324$var$ProductDetailsPage_Lazy.displayName = "ProductDetailsPage_Lazy";
var $cf0bc514c141a324$export$513ccb98c53b8039 = $cf0bc514c141a324$var$component.preload;
var $cf0bc514c141a324$export$dd44f18ab656f3bb = $cf0bc514c141a324$var$ProductDetailsPage_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("cwRuj", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("i1uwo")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("by1hz")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fW0Yj")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6Tuh6")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("WepAH"))
]).then(function() {
    return parcelRequire("Tbt6s");
});

});



parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("8wpG4", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $63453ae6f4ab9cfc$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "$$delete", function () { return $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $63453ae6f4ab9cfc$export$a47fb462a08de82f(key) {
    if (typeof key === "object") {
        var variant = key.NAME;
        if (variant === "optimizeVariant") return "mkr_variant__" + key.VAL + "";
        if (variant === "clientId") return "mkr_client_id__" + key.VAL + "";
    } else {
        if (key === "legacyClientId") return "mkr_client_id";
        if (key === "optimizePreviousEvents") return "mkr_experience_impression";
    }
    var tmp;
    if (typeof key === "object") {
        var variant$1 = key.NAME;
        tmp = variant$1 === "optimizeVariant" ? "optimizeVariant" : variant$1 === "scrollRestoration" ? "scroll-" + key.VAL : variant$1 === "history" ? "history" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "clientId" ? "clientId" : variant$1 === "favorites" ? "favorites" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "selectedMarket" ? "selectedMarket-" + key.VAL : "cart-" + key.VAL;
    } else tmp = key === "debuggerAllowed" ? "debuggerAllowed" : key === "navMenuConfig" ? "navMenuConfig" : key === "legacyClientId" ? "clientId" : key === "gridColumns" ? "gridColumns" : key === "optimizePreviousEvents" ? "optimizePreviousEvents" : "intro";
    return "smartnav__v" + String(2) + "__" + tmp;
}
function $63453ae6f4ab9cfc$export$3988ae62b71be9a3(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            return $2whNH.flatMap($loT9g.null_to_opt($2whNH.getWithDefault(storage, localStorage).getItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key))), function(value) {
                if (value === "") return;
                else return value;
            });
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be(_storage, key, value) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).setItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key), value);
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).removeItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key));
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
var $63453ae6f4ab9cfc$export$83d89fbfd8236492 = 2;
 /* No side effect */ 
});

})();
//# sourceMappingURL=SectionApp.bs.99f93dab.js.map
